import { useIntl } from 'react-intl'

import {
  QuoteSectionClientProposalPricingItemFragment,
  ServiceProviderCategoryEnum,
} from '../../../../../../../../../../lib/graphql'
import { IconProps } from '../../../../../../../../../atoms/icons/icon'

export type QuoteProvisionsCategoriesType = {
  clientPricingItems: QuoteSectionClientProposalPricingItemFragment[]
  categories: ServiceProviderCategoryEnum[]
  label: string
  icon: IconProps['name']
}

export const getQuoteProvisionsCategories = ({
  clientPricingItems,
}: {
  clientPricingItems: QuoteSectionClientProposalPricingItemFragment[]
}): QuoteProvisionsCategoriesType[] => {
  const intl = useIntl()

  const sections: Omit<QuoteProvisionsCategoriesType, 'clientPricingItems'>[] =
    [
      {
        categories: [ServiceProviderCategoryEnum.BATCH_PROVISIONS],
        label: intl.formatMessage({
          id: 'ui.getQuoteProvisionsCategories.batchProvisionsLabel',
          defaultMessage: 'Forfait',
        }),
        icon: 'book',
      },
      {
        categories: [
          ServiceProviderCategoryEnum.HOUSE,
          ServiceProviderCategoryEnum.TAXES,
        ],
        label: intl.formatMessage({
          id: 'ui.getQuoteProvisionsCategories.houseLabel',
          defaultMessage: 'Lieu',
        }),
        icon: 'home-filled',
      },
      {
        categories: [ServiceProviderCategoryEnum.RESTAURATION],
        label: intl.formatMessage({
          id: 'ui.getQuoteProvisionsCategories.restorationLabel',
          defaultMessage: 'Restauration',
        }),
        icon: 'restaurant',
      },
      {
        categories: [ServiceProviderCategoryEnum.ACTIVITY],
        label: intl.formatMessage({
          id: 'ui.getQuoteProvisionsCategories.activitiesLabel',
          defaultMessage: 'Activités',
        }),
        icon: 'challenge-sport',
      },
      {
        categories: [ServiceProviderCategoryEnum.TRANSPORT],
        label: intl.formatMessage({
          id: 'ui.getQuoteProvisionsCategories.transportLabel',
          defaultMessage: 'Transport',
        }),
        icon: 'train',
      },
    ]
  const formattedSections = sections
    .map((section) => {
      const filteredItems = clientPricingItems.filter((item) =>
        section.categories.includes(item.category),
      )
      const sortedItems = sortItemsByPosition(filteredItems)
      return { ...section, clientPricingItems: sortedItems }
    })
    .filter((section) => section.clientPricingItems.length > 0)

  return formattedSections
}

const sortItemsByPosition = (
  items: QuoteSectionClientProposalPricingItemFragment[],
) =>
  items.sort((a, b) => {
    if (a.position == null && b.position == null) {
      return 0
    }
    if (a.position == null) {
      return -1
    }
    if (b.position == null) {
      return 1
    }
    return a.position - b.position
  })
